import { render, staticRenderFns } from "./ShoppingListDemoBanner.vue?vue&type=template&id=3efd76d0&"
import script from "./ShoppingListDemoBanner.vue?vue&type=script&lang=ts&"
export * from "./ShoppingListDemoBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports